import { AppDispatch } from '@store/AppState';
import { getContract } from '@store/essential-ui/contract/ContractSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentOffer } from './UseCurrentOffer';

export const useSetContract = (
  closedDealId: string,
  chromeId?: string,
  dealerId?: string,
): void => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentOffer } = useCurrentOffer(closedDealId);

  useEffect(() => {
    dispatch(
      getContract({
        id: closedDealId,
        dealerId: dealerId!,
        chromeId: chromeId ?? currentOffer!.chromeId.toString(),
      }),
    );
  }, [closedDealId]);
};
